/*
* DatagridCalculatedField component specific for Adalia M&E.
*
* Calculate fields from datagrids - Use presets to define the calculation/filter logic. Functions in project context.
*
* Project can be passed as a prop, but if not, this component expects the document to contain an element with an id report-container
* and that element have a data-attribute called project-id.
*
*/

import React from 'react';
import update from 'immutability-helper';

import { Base } from '../../form_components.jsx';
import Setting from '../setting.jsx'
import Helpers from '../helpers.jsx';
import { castDataType, DataType, Mode } from '../../common.jsx';

// Temp component to be used for demo inside prefil_groups_repeatable
export default class AdaliaMeDatagridAggregatedField extends Base {
  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_datagrid_aggregated_field';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_aggregated_field',
      description: 'field_default_description',
      help: null,
    };
  }

  static icon() {
    return <i className='fa fa-calculator'></i>;
  }

  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      name: 'field_' + Helpers.randomString(),
    });
  }

  // Calculation can be done to any component
  static resolveRelatedAnswerNamesOrIds(content, repeatedFieldScope = "") {
  
    let names = [];
    if (content.name) {
      names.push(repeatedFieldScope + "[" + content.name + "]");
    }
    let variables = (content.groupKeys || []).map((v) => repeatedFieldScope + "[" + v + "]");
    return [...variables, ...names];
  }

  constructor(props) {
    super(props);

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    super.componentDidMount();

    let project_id = this.props.project?.id || jQuery('#report-container').data('project-id');

    if (!project_id || [Mode.EDIT, Mode.SETTINGS].includes(this.props.mode)) {
      this.setState({
        loading: false
      });

    }
  }

  renderView() {
    return (
      <div>
        <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
          <span className='field-label'>{this.getText('label')}</span>
          {this.helpIcon()}
          {this.descriptionText()}
        </label>
        <input name={this.fullFieldName()} className='form-control' value={this.getAnswer()} readOnly/>
      </div>
    );
  }

  renderSettings() {
    return (
      <div>
        <div className="setting">
          <label>
            {I18n.t('component_name', {scope: 'fe'})}
          </label>
          <div className='option-groups'>
            {this.props.content.presetName}
          </div>
        </div>

        <Setting.TextField name='label' label={I18n.t('field_label', {scope: 'fe'})} value={this.getText("label")} onChange={this.updateSettings} />
        <Setting.Checkbox name='label_hidden' className='label-hidden-check' label={I18n.t('field_label_hide', {scope: 'fe'})} value={this.props.content.label_hidden} onChange={this.updateSettings} />
        <Setting.TextField name='label_for_calculated_field' label={I18n.t('label_for_calculated_field', {scope: 'fe'})} value={this.props.content.label_for_calculated_field} onChange={this.updateSettings} />
        
        <Setting.TextField name='groupKeys' label={I18n.t('groupKeys', {scope: 'fe'})} value={this.props.content.groupKeys} onChange={this.updateSettings} />
        <Setting.TextField name='colAccessor' label={I18n.t('colAccessor', {scope: 'fe'})} value={this.props.content.colAccessor} onChange={this.updateSettings} />
      </div>
      
    );
  }

  beforeUpdateSettings(content) {
    content.label_hidden = castDataType(content.label_hidden, DataType.BOOLEAN);
    content.groupKeys = typeof content.groupKeys == 'string' ? content.groupKeys.split(',').filter(a => !!a) : content.groupKeys
  }
}


